import React from 'react';
import { Redirect } from 'react-router-dom';

export const InstancesRedirect: React.FC = (): JSX.Element => <Redirect to="/instances" />;
